import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDatabaseError = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.25 7c0 1.105-3.384 2.25-7.25 2.25S4.75 8.105 4.75 7 8.134 4.75 12 4.75 19.25 5.895 19.25 7M19.25 10.25V7M4.75 17V7M9.25 14.061C7 14 4.75 12.834 4.75 12M9.25 19.25C7 19.189 4.75 17.834 4.75 17M19.25 16a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0M14 14l4 4"
    />
  </svg>
);
export default SvgDatabaseError;
